import { createApp } from 'vue'
import App from './App.vue'

import SocketIO from 'socket.io-client'
import VueSocketIO from 'vue-3-socket.io'

// get url parameters
const urlSearchParams = new URL(window.location).searchParams

// product mode 에서는 token 을 was 가 받아서 넘겨주도록 한다.
const chatUrl = (window.innoLiveChatInitParam && window.innoLiveChatInitParam.chatUrl)
            ? window.innoLiveChatInitParam.chatUrl
            : (urlSearchParams.get('chatUrl') || 'http://localhost')
const token = (window.innoLiveChatInitParam && window.innoLiveChatInitParam.token)
            ? window.innoLiveChatInitParam.token 
            : (urlSearchParams.get('token') || 'Invalid Token.')

window.innoLiveChatInitParam.chatUrl = chatUrl
window.innoLiveChatInitParam.token = token
// console.log('chatUrl: ', chatUrl, 'token: ', token)
const SocketInstance = SocketIO.connect(chatUrl, {
    query: {
        token: token
    },
    reconnection: false, // 자동 재연결을 하지 말것. 1회용 토큰 사용으로 제한 됨
    transports: ['websocket']
})

// const app = createApp(App).use(new VueSocketIO({
const app = createApp(App)
app.provide('innoLiveChatInitParam', window.innoLiveChatInitParam)
app.use(new VueSocketIO({
    debug: false,
    connection: SocketInstance,
    // autoConnect: false,
}), SocketInstance)
app.mount('#innolivechat')
